import { Box, Typography, Slider } from '@mui/material';
import React from 'react';

type YardlinePosition = {
    value: number;
    label: string;
  };
  
const YARDLINE_POSITIONS: YardlinePosition[] = [
    { value: 0, label: 'Endzone' },
    ...Array.from({ length: 49 }, (_, i) => ({ value: -(i + 1), label: `${-(i + 1)}` })),
    { value: 50, label: '50' },
    ...Array.from({ length: 49 }, (_, i) => ({ value: 49 - i, label: `${49 - i}` }))
  ];
export const YardlineSlider: React.FC<{
    value: number;
    onChange: (value: number) => void;
    label: string;
  }> = ({ value, onChange, label }) => {
    // Create an array of indices that maps to the correct order of yardlines
    const orderedIndices = YARDLINE_POSITIONS.map((_, index) => index);
    
    // Find the current index in our ordered list
    const currentIndex = YARDLINE_POSITIONS.findIndex(pos => pos.value === value);
  
    // Only label every 10th yardline, Endzone, and 50
    const marks = YARDLINE_POSITIONS.map((pos, index) => {
      if (
        pos.value === 0 ||
        pos.value === 50 ||
        pos.value === -40 ||
        pos.value === -30 ||
        pos.value === -20 ||
        pos.value === -10 ||
        pos.value === 40 ||
        pos.value === 30 ||
        pos.value === 20 ||
        pos.value === 10 ||
        pos.value === 1
      ) {
        return { value: index, label: pos.label };
      }
      return { value: index };
    });
  
    // Find the label for the current value
    const currentLabel = YARDLINE_POSITIONS[currentIndex]?.label ?? value.toString();
  
    return (
      <Box sx={{ width: '100%', px: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 1 }}>
          <Typography id={`${label}-slider-label`} gutterBottom>
            {label}
          </Typography>
          <Typography variant="subtitle1" sx={{ mt: 0.5, fontWeight: 'bold' }}>
            {currentLabel}
          </Typography>
        </Box>
        <Slider
          value={currentIndex}
          onChange={(_event, newValue) => {
            const newIndex = newValue as number;
            onChange(YARDLINE_POSITIONS[newIndex].value);
          }}
          aria-labelledby={`${label}-slider-label`}
          step={null}
          marks={marks}
          min={0}
          max={YARDLINE_POSITIONS.length - 1}
          valueLabelDisplay="auto"
          valueLabelFormat={(index) => YARDLINE_POSITIONS[index].label}
          sx={{
            '& .MuiSlider-markLabel': {
              fontSize: '0.75rem',
            },
            '& .MuiSlider-valueLabel': {
              fontSize: '0.875rem',
            }
          }}
        />
      </Box>
    );
  };